import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Swal from "sweetalert2"; // Import SweetAlert2

const Contact = () => {
  // State to store form data
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  // State to store form status (optional)
  const [formStatus, setFormStatus] = useState({
    loading: false,
    success: false,
    error: "",
  });

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    setFormStatus({ ...formStatus, loading: true, error: "" });

    try {
      // Make POST request to the backend API
      const response = await axios.post(
        "https://mesoperations.com/api/api/contact/",
        formData
      );

      // Handle success response
      if (response.status === 201 || response.status === 200) {
        setFormStatus({ loading: false, success: true, error: "" });
        setFormData({ name: "", email: "", mobile: "", message: "" }); // Clear form

        // Show success alert
        Swal.fire({
          icon: "success",
          title: "Message Sent!",
          text: "Your message has been sent successfully.",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      setFormStatus({
        loading: false,
        success: false,
        error: "Failed to send the message. Please try again.",
      });

      // Show error alert
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to send the message. Please try again.",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div>
      <div className="banner">
        <img src="assets/img/contact.jpg" alt="Contact" />
      </div>
      <section id="contact" className="contact section">
        <div className="container section-title" data-aos="fade-up">
          <h2>Contact</h2>
          <p>Get in touch with us for any inquiries or assistance.</p>
        </div>

        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row gy-4">
            <div className="col-lg-6">
              <div className="row gy-4">
                <div className="col-md-6">
                  <div
                    className="info-item"
                    data-aos="fade"
                    data-aos-delay="200"
                  >
                    <i className="bi bi-geo-alt"></i>
                    <h3>Address</h3>
                    <p>
                      SF No.25/40, Plot no. 90, Dhanraj Nagar, T.V. Main Road,
                      Ekkatuthangal, Chennai.
                    </p>
                  </div>
                </div>

                <div className="col-md-6">
                  <div
                    className="info-item"
                    data-aos="fade"
                    data-aos-delay="300"
                  >
                    <i className="bi bi-telephone"></i>
                    <h3>Call Us</h3>
                    <p>
                      <Link to="tel:+91 794382016">98766543211</Link>
                    </p>
                  </div>
                </div>

                <div className="col-md-6">
                  <div
                    className="info-item"
                    data-aos="fade"
                    data-aos-delay="400"
                  >
                    <i className="bi bi-envelope"></i>
                    <h3>Email Us</h3>
                    <Link to="mailto:fenice.com">
                      fenicechemical.com
                    </Link>
                    <br />
                    <Link to="mailto:hr.com">
                      feniceshieldchemical.com
                    </Link>
                  </div>
                </div>

                <div className="col-md-6">
                  <div
                    className="info-item"
                    data-aos="fade"
                    data-aos-delay="500"
                  >
                    <i className="bi bi-clock"></i>
                    <h3>Open Hours</h3>
                    <p>Monday - Friday</p>
                    <p>9:00AM - 05:00PM</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <form
                onSubmit={handleSubmit}
                className="php-email-form"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="row gy-4">
                  <div className="col-md-6">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="col-12">
                    <input
                      type="number"
                      name="mobile"
                      className="form-control"
                      placeholder="Mobile"
                      value={formData.mobile}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="col-12">
                    <textarea
                      name="message"
                      className="form-control"
                      rows="6"
                      placeholder="Message"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                    ></textarea>
                  </div>

                  <div className="col-12 text-center">
                    {formStatus.loading && (
                      <div className="loading">Loading...</div>
                    )}
                    {formStatus.success && (
                      <div className="sent-message">
                        Your message has been sent. Thank you!
                      </div>
                    )}
                    {formStatus.error && (
                      <div className="error-message">{formStatus.error}</div>
                    )}
                    <button type="submit" disabled={formStatus.loading}>
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
